import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { CYAN, YELLOW, GREEN } from '../../HOME/const';
import _ from 'lodash';
import { setInit } from '../REDUX/actions';
import { formatTime } from '../../HOME/utils';

const Scoreboard = props => {
  const handleLevelSelection = level => {
    props.setInit(level);
  };

  if (props.practice) {
    const level = props.level || 1;

    return (
      <div className="nm-level-selector">
        <div style={{ gridArea: '1/1', marginRight: '10px' }}>Select level:</div>
        {_.map([1, 2, 3, 4, 5, 6, 7, 8], i => {
          return (
            <div
              key={i}
              className="nm-level-selection"
              style={{ gridArea: `1/${1 + i}`, border: `${i === level ? '1px solid white' : 'initial'}` }}
              onClick={() => handleLevelSelection(i)}>
              <span style={{ marginTop: '-1px' }}>{i}</span>
            </div>
          );
        })}
      </div>
    );
  }

  const { stats } = props;
  const { plays, aveScore, bestScore } = stats;

  return (
    <div className="tt-scoreboard">
      <span style={{ gridArea: '1/1/1/span 2', color: YELLOW }}>{plays || 0}</span>
      <span style={{ gridArea: '2/1/2/span 2', marginTop: '-1px' }}>plays</span>
      <span style={{ gridArea: '1/2/1/span 2', color: GREEN }}>{aveScore || 0}</span>
      <span style={{ gridArea: '2/2/2/span 2', marginTop: '-1px' }}>ave. score</span>

      <span className="nm-quartz" style={{ gridArea: '3/1', color: YELLOW }}>
        {bestScore || 0}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/1' }}>
        best score
      </span>

      <span className="nm-quartz" style={{ gridArea: '3/2', color: CYAN }}>
        {formatTime(props.secs)}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/2' }}>
        time left
      </span>

      <span className="nm-quartz" style={{ gridArea: '3/3', color: GREEN }}>
        {props.score || 0}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/3' }}>
        score
      </span>
    </div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { setInit }
)(Scoreboard);
